import { HomepageService } from "src/app/services/homepage.service";
import { WalletAPIService } from "../../../services/walletAPI.service";
import { Component, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { NotifierService } from "angular-notifier";
import { DOCUMENT } from "@angular/common";
import { RouterExtService } from "src/app/services/previous-route.service";
import { AppMonitoringService } from "src/app/services/logging.service";
@Component({
  selector: "app-id-cards",
  templateUrl: "./id-cards.component.html",
  styleUrls: ["./id-cards.component.css"],
})
export class IdCardsComponent implements OnInit {
  @ViewChild('walletButton') walletButton!: ElementRef;
  mobileOS: string = "";
  libraryCard: any = [];
  dateFormat: string = "M/d/yyyy";
  colors: string;
  imageName: string;
  patronName: any;
  gloalSetting: any = [];
  loading:boolean = false;
  walletLink: string = "";
  isNewPass: boolean = false;
  constructor(
    private service: WalletAPIService,
    private homepageService: HomepageService,
     @Inject(DOCUMENT) private document: Document,
     private notifier: NotifierService,
     private routerService: RouterExtService,
     private appMonitoringService: AppMonitoringService
  ) {}
  ngOnInit() {
    this.document.body.classList.add('inner-page');
    this.document.body.classList.add('list');
    this.routerService.setTextUrl('Library Card');
    this.mobileOS = this.service.getMobileOS();
    this.gloalSetting =   this.homepageService.getUpdatedConfig();

    this.homepageService.isCardRoute$.subscribe((resultList: any) => {
      if(resultList == 'true'){
        this.getLibraryCardDetail();
      }else{
        this.getLibraryCardDetail();
      }
    });

  }

  getLibraryCardDetail() {
    this.loading = true;
    this.homepageService.getLibraryCard().subscribe(
      (data: any) => {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.loading = false;
        this.libraryCard = data.data;
        this.dateFormat = this.homepageService.formatDate();
        this.colors = this.homepageService.bgColor(data.data.number);
        this.patronName = data.data.firstName + " " + data.data.lastName;
        this.imageName = this.homepageService.initialName(this.patronName);
        if(this.gloalSetting.data.settings.patron.libraryCard?.enabled && this.gloalSetting.data.settings.patron.libraryCard?.enabledAppleWallet && (this.mobileOS == 'Android')){
          this.getWalletLink(data.data.email)
        }
      },
      (error) => {
        this.loading = false;
        setTimeout(function(){
          var button = $("a#loginLia");
          button[0].click();
        },1000);
      }
    );
  }

  getWalletLink(email: string){
    if(this.mobileOS == 'Android'){
      this.service.getWalletLink({email: email}).subscribe(
        (data: any) => {
          // this.appMonitoringService.logEvent("Android Link Generated", { userAgent: data.data });
          this.walletLink =  data.data.googleWalletLink;
          this.isNewPass =  data.data.isNewPass;
        },
        (error) => {
          this.appMonitoringService.logException(error, 1);
        }
      );
    }
  }
  getAppleWalletLink(){
    this.appMonitoringService.logEvent("Apple Wallet Link Clicked details", { libraryCard: this.gloalSetting.data.settings.patron.libraryCard });
    if(this.gloalSetting.data.settings.patron.libraryCard?.enabled && this.gloalSetting.data.settings.patron.libraryCard?.enabledGoogleWallet && (this.mobileOS == 'iOS')){
    this.service.getAppleWalletLink().subscribe(
      (data: any) => {
        // this.appMonitoringService.logEvent("Apple Link Generated", { userAgent: data.data });
        const blob = new Blob([data.data], { type: 'application/vnd.apple.pkpass' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'MyPass.pkpass';
        a.click();

        window.URL.revokeObjectURL(url);
        this.isNewPass =  data.isNewPass;
      },
      (error) => {
        this.appMonitoringService.logException(error, 1);
      }
    );
  }
  }
}
